import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ServiceViewVue from "@/views/ServiceView.vue";
import LoginViewVue from "@/views/Dashboard/LoginView.vue";
import AdminHomeVue from "@/views/Dashboard/AdminHome.vue";
import ServicesView from "@/views/Dashboard/Services/ServicesView.vue";
import AddService from "@/views/Dashboard/Services/AddService.vue";
import UpdateService from "@/views/Dashboard/Services/UpdateService.vue";
import ProductsView from "@/views/Dashboard/Products/ProductsView.vue";
import AddProduct from "@/views/Dashboard/Products/AddProduct.vue";
import UpdateProduct from "@/views/Dashboard/Products/UpdateProduct.vue";
import NewsView from "@/views/Dashboard/News/NewsView.vue";
import AddBlog from "@/views/Dashboard/News/AddBlog.vue";
import UpdateBlog from "@/views/Dashboard/News/UpdateBlog.vue";
import NewsVue from "@/views/News/NewsVue.vue";
import NewsDetails from "@/views/News/NewsDetails.vue";
import TeamView from "@/views/Dashboard/Team/TeamView.vue";
import AddTeam from "@/views/Dashboard/Team/AddTeam.vue";
import UpdateTeam from "@/views/Dashboard/Team/UpdateTeam.vue";
import AddClient from "@/views/Dashboard/Clients/AddClient.vue";
import UpdateClient from "@/views/Dashboard/Clients/UpdateClient.vue";
import ClientsView from "@/views/Dashboard/Clients/ClientsView.vue";
import StoriesView from "@/views/Dashboard/Stories/StoriesView.vue";
import AddStory from "@/views/Dashboard/Stories/AddStory.vue";
import UpdateStory from "@/views/Dashboard/Stories/UpdateStory.vue";
import StoriesVueView from "@/views/Stories/StoriesVue.vue";
import StoryDetails from "@/views/Stories/StoryDetails.vue";
import OurPartnersView from "@/views/Dashboard/Our Partners/OurPartnersView.vue";
import AddOurPartners from "@/views/Dashboard/Our Partners/AddOurPartners.vue";
import UpdateOurPartners from "@/views/Dashboard/Our Partners/UpdateOurPartners.vue";
import OurPartners from "@/views/OurPartners/OurPartners.vue";
import CompanyNumbersView from "@/views/Dashboard/CompanyNumbers/CompanyNumbersView.vue";
import AddCompanyNumbers from "@/views/Dashboard/CompanyNumbers/AddCompanyNumbers.vue";
import UpdateCompanyNumbers from "@/views/Dashboard/CompanyNumbers/UpdateCompanyNumbers.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/service",
    name: "ServiceViewVue",
    component: ServiceViewVue,
  },
  {
    path: "/login",
    name: "LoginViewVue",
    component: LoginViewVue,
  },
  {
    path: "/AdminHome",
    name: "AdminHomeVue",
    component: AdminHomeVue,
  },
  {
    path: "/AdminServicesView",
    name: "ServicesView",
    component: ServicesView,
  },
  {
    path: "/AddService",
    name: "AddService",
    component: AddService,
  },
  {
    path: "/update-service",
    name: "UpdateService",
    component: UpdateService,
  },
  {
    path: "/ProductsView",
    name: "ProductsView",
    component: ProductsView,
  },
  {
    path: "/AddProduct",
    name: "AddProduct",
    component: AddProduct,
  },
  {
    path: "/update-product",
    name: "UpdateProduct",
    component: UpdateProduct,
  },
  {
    path: "/NewsView",
    name: "NewsView",
    component: NewsView,
  },
  {
    path: "/AddBlog",
    name: "AddBlog",
    component: AddBlog,
  },
  {
    path: "/update-blog",
    name: "UpdateBlog",
    component: UpdateBlog,
  },
  {
    path: "/news",
    name: "NewsVue",
    component: NewsVue,
  },
  {
    path: "/news-details",
    name: "NewsDetails",
    component: NewsDetails,
  },
  {
    path: "/TeamView",
    name: "TeamView",
    component: TeamView,
  },
  {
    path: "/AddTeam",
    name: "AddTeam",
    component: AddTeam,
  },
  {
    path: "/update-team",
    name: "UpdateTeam",
    component: UpdateTeam,
  },
  {
    path: "/PartnersView",
    name: "ClientsView",
    component: ClientsView,
  },
  {
    path: "/AddPartners",
    name: "AddClient",
    component: AddClient,
  },
  {
    path: "/StoriesView",
    name: "StoriesView",
    component: StoriesView,
  },
  {
    path: "/AddStory",
    name: "AddStory",
    component: AddStory,
  },
  {
    path: "/update-story",
    name: "UpdateStory",
    component: UpdateStory,
  },
  {
    path: "/success-stories",
    name: "StoriesVueView",
    component: StoriesVueView,
  },
  {
    path: "/story-details",
    name: "StoryDetails",
    component: StoryDetails,
  },
  {
    path: "/OurPartnersView",
    name: "OurPartnersView",
    component: OurPartnersView,
  },
  {
    path: "/AddNewPartners",
    name: "AddOurPartners",
    component: AddOurPartners,
  },
  {
    path: "/update-partner",
    name: "UpdateOurPartners",
    component: UpdateOurPartners,
  },
  {
    path: "/update-client",
    name: "UpdateClient",
    component: UpdateClient,
  },
  {
    path: "/our-partners",
    name: "OurPartners",
    component: OurPartners,
  },
  {
    path: "/CompanyNumbersView",
    name: "CompanyNumbersView",
    component: CompanyNumbersView,
  },
  {
    path: "/AddCompanyNumbers",
    name: "AddCompanyNumbers",
    component: AddCompanyNumbers,
  },
  {
    path: "/update-numbers",
    name: "UpdateCompanyNumbers",
    component: UpdateCompanyNumbers,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
